import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export function ifNullOrUndefined<T>(missingValue: T) {
  return (source$: Observable<null | undefined | T>) => source$.pipe(map(value => value ?? missingValue));
}
